/**
 * Every string the web help-and-about card renders.
 *
 * The four URLs are the same pages the phone app opens
 * (`apps/mobile/app/account/settings.tsx:37-40`), written in the canonical
 * trailing-slash form each page declares. The bare form answers a 301 to it,
 * and a browser that cached the old redirect to an internal port before
 * 2026-09-19 still follows that dead one (ISSUE-971). The colocated test
 * pins them.
 */

import { APP_VERSION } from "../../appVersion";

export const HELP_AND_ABOUT_TITLE = "Help and about";
/**
 * The marketing site's home page. A signed-out visitor's way back out of the
 * app: the wordmark and the "Go to home" links point here when there is no
 * session, because app `/` only returns them to sign-in (ISSUE-1101 R5).
 */
export const SPORTSMET_SITE_URL = "https://sportsmet.com/";
export const SUPPORT_URL = "https://sportsmet.com/support/";
export const TERMS_URL = "https://sportsmet.com/terms/";
export const PRIVACY_URL = "https://sportsmet.com/privacy-policy/";
export const COOKIE_URL = "https://sportsmet.com/cookie-policy/";
export const EXTERNAL_LINK_HINT = "Opens in a new tab";

export type typeHelpRow = {
  /** Suffix of the row's testID: `help-row-${key}`. */
  key: "support" | "terms" | "privacy" | "cookie";
  label: string;
  href: string;
};

export const HELP_ROWS: readonly typeHelpRow[] = [
  { key: "support", label: "Get help", href: SUPPORT_URL },
  { key: "terms", label: "Terms of service", href: TERMS_URL },
  { key: "privacy", label: "Privacy policy", href: PRIVACY_URL },
  { key: "cookie", label: "Cookie policy", href: COOKIE_URL },
] as const;

export function buildVersionLine(): string {
  return `Version ${APP_VERSION}`;
}
